// Helper function untuk menghitung hemat
export const calculateHemat = (pid, billingcycle, actualPrice, monthlyPrice) => {
  // Data harga monthly ASLI (tanpa diskon) untuk setiap PID
  const monthlyPricesData = {
    1124: 60000,   // Cloud Hosting Micro
    1125: 96000,   // Cloud Hosting Starter  
    1126: 80000,   // Cloud Hosting Lite - harga monthly asli (tanpa diskon)
    1127: 246000,  // Cloud Hosting SOHO
    1128: 396000,  // Cloud Hosting Business
    1129: 576000,  // Cloud Hosting Expert
    1130: 876000,  // Cloud Hosting Corporate
    1131: 1296000, // Cloud Hosting Enterprise
    // Cloud Hosting Premium (Maxmail, Proxima, Hyper Quantum)
    // Note: Untuk GID 729-731, harga akan diambil dari monthlyPrice parameter
    526: 63500,
    528: 21000,
    530: 78000,
    532: 41500,
    534: 119000,
    536: 81000,
    976: 119000,
    538: 232000,
    540: 181000,
    975: 232000,
    1006: 28000,
    1007: 80000,
    1008: 170000,
    1009: 300000,
  };

  // Mapping termin ke jumlah bulan
  const monthsMap = {
    monthly: 1,
    quarterly: 3,
    semiannually: 6,
    annually: 12,
    biennially: 24,
    triennially: 36,
  };

  const months = monthsMap[billingcycle] || 1;
  
  // Hitung hemat hanya jika durasi > 1 bulan
  if (months <= 1) return { hematAmount: 0, originalPrice: null };
  
  // Kondisi khusus untuk PID 1124-1143 atau produk premium dengan monthlyPrice
  if (((pid >= 1124 && pid <= 1143) || monthlyPrice) && monthlyPrice) {
    const originalPrice = monthlyPrice * months;
    const hematAmount = originalPrice - actualPrice;
    
    return {
      hematAmount: hematAmount > 0 ? hematAmount : 0,
      originalPrice: originalPrice
    };
  }
  
  // Untuk PID lain, gunakan data static
  const baseMonthlyPrice = monthlyPricesData[pid];
  if (!baseMonthlyPrice) return { hematAmount: 0, originalPrice: null };
  
  const originalPrice = baseMonthlyPrice * months;
  const hematAmount = originalPrice - actualPrice;
  
  return {
    hematAmount: hematAmount > 0 ? hematAmount : 0,
    originalPrice: originalPrice
  };
};

// Fallback untuk perhitungan hemat berdasarkan data static lama (untuk PID yang tidak ada di data baru)
export const calculateHematFallback = (pid, billingcycle, actualPrice) => {
  const discounts = {
    annually: {
      526: 30, 528: 30, 530: 10, 532: 10, 534: 20, 536: 20, 976: 20,
      538: 40, 540: 40, 975: 40, 1006: 10, 1009: 20,
    },
    monthly: { 1007: 20, 1008: 30 },
    quarterly: { 1007: 20, 1008: 30 },
    semiannually: { 1007: 20, 1008: 30 },
  };

  const staticPrices = {
    annually: {
      528: 252000, 526: 762000, 530: 936000, 532: 498000,
      534: 1428000, 976: 1428000, 536: 972000, 540: 2172000,
      538: 2784000, 975: 2784000, 1006: 336000, 1009: 3600000,
    },
    monthly: { 1007: 80000, 1008: 170000 },
    quarterly: { 1007: 240000, 1008: 510000 },
    semiannually: { 1007: 480000, 1008: 1020000 },
  };

  const discount = discounts[billingcycle]?.[pid];
  const originalPrice = staticPrices[billingcycle]?.[pid];

  if (discount && originalPrice) {
    const hematAmount = originalPrice - actualPrice;
    return {
      hematAmount: hematAmount > 0 ? hematAmount : 0,
      originalPrice: originalPrice
    };
  }

  return { hematAmount: 0, originalPrice: null };
}; 